const CONFIGS = {
  dev: {
    API_URL: 'http://localhost:8000/v1/',
    API_URL_V2: 'http://localhost:8000/v2/',
    SOCKET_URL: 'http://localhost:8000',
    REDIRECT_URI: 'http://localhost:8080',
    MSFT_REDIRECT_URI_REGISTRATION: 'http://localhost:8080/register/v3',
    MSFT_REDIRECT_URI_LOGIN: 'http://localhost:8080/login',
  },
  staging: {
    API_URL: 'https://sourcerer-ai-staging.herokuapp.com/v1/',
    API_URL_V2: 'https://sourcerer-ai-staging.herokuapp.com/v2/',
    SOCKET_URL: 'https://sourcerer-ai-staging.herokuapp.com',
    REDIRECT_URI: 'https://hirefly-web-client-staging.herokuapp.com',
    MSFT_REDIRECT_URI_REGISTRATION:
      'https://hirefly-web-client-staging.herokuapp.com/register/v3',
    MSFT_REDIRECT_URI_LOGIN:
      'https://hirefly-web-client-staging.herokuapp.com/login',
  },
  sandbox: {
    API_URL: 'https://www.backend.hireflyrecruitment.com/v1/',
    API_URL_V2: 'https://www.backend.hireflyrecruitment.com/v2/',
    SOCKET_URL: 'https://www.backend.hireflyrecruitment.com',
    REDIRECT_URI: 'https://www.hireflyrecruitment.com',
    MSFT_REDIRECT_URI_REGISTRATION:
      'https://www.hireflyrecruitment.com/register/v3',
    MSFT_REDIRECT_URI_LOGIN: 'https://www.hireflyrecruitment.com/login',
  },
  canary: {
    API_URL: 'https://sourcerer-ai.herokuapp.com/v1/',
    API_URL_V2: 'https://sourcerer-ai.herokuapp.com/v2/',
    SOCKET_URL: 'https://sourcerer-ai.herokuapp.com',
    REDIRECT_URI: 'https://hirefly-web-client-canary.herokuapp.com',
    MSFT_REDIRECT_URI_REGISTRATION:
      'https://hirefly-web-client-canary.herokuapp.com/register/v3',
    MSFT_REDIRECT_URI_LOGIN:
      'https://hirefly-web-client-canary.herokuapp.com/login',
  },
  prod: {
    API_URL: 'https://sourcerer-ai.herokuapp.com/v1/',
    API_URL_V2: 'https://sourcerer-ai.herokuapp.com/v2/',
    SOCKET_URL: 'https://sourcerer-ai.herokuapp.com',
    REDIRECT_URI: 'https://www.hirefly.ai',
    MSFT_REDIRECT_URI_REGISTRATION: 'https://www.hirefly.ai/register/v3',
    MSFT_REDIRECT_URI_LOGIN: 'https://www.hirefly.ai/login',
  },
  proxy: {
    API_URL: 'https://sourcerer-ai-staging.herokuapp.com/v1/',
    API_URL_V2: 'https://sourcerer-ai-staging.herokuapp.com/v2/',
    SOCKET_URL: 'https://sourcerer-ai-staging.herokuapp.com',
    REDIRECT_URI: 'https://proxy.hirefly.ai',
    MSFT_REDIRECT_URI_REGISTRATION: 'https://proxy.hirefly.ai/register/v3',
    MSFT_REDIRECT_URI_LOGIN: 'https://proxy.hirefly.ai/login',
  },
  proxy_staging: {
    API_URL: 'https://sourcerer-ai-staging.herokuapp.com/v1/',
    API_URL_V2: 'https://sourcerer-ai-staging.herokuapp.com/v2/',
    SOCKET_URL: 'https://sourcerer-ai-staging.herokuapp.com',
    REDIRECT_URI: 'https://hirefly-proxy-staging-2062d1579522.herokuapp.com',
    MSFT_REDIRECT_URI_REGISTRATION:
      'https://hirefly-proxy-staging-2062d1579522.herokuapp.com/register/v3',
    MSFT_REDIRECT_URI_LOGIN:
      'https://hirefly-proxy-staging-2062d1579522.herokuapp.com/login',
    IS_V2: false,
    AMPLITUDE_KEY: 'c5f40607c3922d1376239f870d766569',
    CURRENT_ENV: 'proxy_staging',
  },
  v2_feature: {
    API_URL: 'https://sourcerer-ai-staging.herokuapp.com/v1/',
    API_URL_V2: 'https://sourcerer-ai-staging.herokuapp.com/v2/',
    SOCKET_URL: 'https://sourcerer-ai-staging.herokuapp.com',
    REDIRECT_URI: 'https://hirefly-v2-feature-1bc203bdd9ab.herokuapp.com',
    MSFT_REDIRECT_URI_REGISTRATION:
      'https://hirefly-backend-feature-5d0a15f6edb7.herokuapp.com/register/v3',
    MSFT_REDIRECT_URI_LOGIN:
      'https://hirefly-backend-feature-5d0a15f6edb7.herokuapp.com/login',
    IS_V2: false,
    AMPLITUDE_KEY: '24269b95d2225ffa81f4cb6237134ef5',
    USERPILOT_TOKEN: 'STG-NX-6c04844c',
    COMMAND_BAR_ORG_ID: '378fdef3',
    CURRENT_ENV: 'staging_v2',
  },
};

class Config {
  static environment;

  static initialize() {
    if (!Config.environment) {
      const { hostname } = window.location;
      if (
        hostname === 'hirefly.ai' ||
        hostname === 'www.hirefly.ai' ||
        hostname === 'hirefly-web-client.herokuapp.com'
      ) {
        Config.environment = CONFIGS.prod;
      } else if (hostname === 'hirefly-web-client-canary.herokuapp.com') {
        Config.environment = CONFIGS.canary;
      } else if (hostname === 'hirefly-web-client-staging.herokuapp.com') {
        Config.environment = CONFIGS.staging;
      } else if (hostname === 'www.hireflyrecruitment.com') {
        Config.environment = CONFIGS.sandbox;
      } else if (hostname === 'proxy.hirefly.ai') {
        Config.environment = CONFIGS.proxy;
      } else if (
        hostname === 'hirefly-proxy-staging-2062d1579522.herokuapp.com'
      ) {
        Config.environment = CONFIGS.proxy_staging;
      } else if (hostname === 'hirefly-v2-feature-1bc203bdd9ab.herokuapp.com') {
        Config.environment = CONFIGS.v2_feature;
      } else {
        Config.environment = CONFIGS.dev;
      }
    }
  }

  static get env() {
    Config.initialize();
    return Config.environment;
  }
}

export default Config;
